import React, { useState } from "react";
import SharedHelmet from "../Helmet";
const TITLE = "تحويل وحدات المساحة - أداة لتحويل قياسات المساحات بدقة";
const DESCRIPTION = "حوّل قياسات المساحات بين مختلف الوحدات بدقة وسهولة باستخدام أداة تحويل وحدات المساحة. اختر الوحدة الأصلية والوحدة المستهدفة للحصول على النتائج بسرعة. مثالية للمهندسين والمعماريين والمصممين.";
const KEYWORDS = "تحويل وحدات المساحة, محول وحدات المساحة, حاسبة تحويل المساحات, أدوات قياس, قياس المساحات";
const OG_URL = "https://do-calculate.com/calculator/ar/unit_converter/area/";
const areaParameters = {
  sqm: "متر مربع",
  sqkm: "كيلومتر مربع",
  sqcm: "سنتيمتر مربع",
  sqmm: "ميليمتر مربع",
  sqmcm: "مايكرومتر مربع",
  hectare: "هكتار",
  sqmile: "ميل مربع",
  sqyard: "ياردة مربعة",
  sqfoot: "قدم مربع",
  sqinch: "بوصة مربعة",
  acre: "فدان",
};
const areas = Object.keys(areaParameters);
function UnitsList() {
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const renderTable = (parameters, parameterNames) => (
    <table >
      <thead>
        <tr>
          <th >من الوحدة</th>
          <th >إلى الوحدة</th>
          <th >رابط الحاسبة</th>
        </tr>
      </thead>
      <tbody>
        {parameters
          .filter((fromParams) =>
            parameterNames[fromParams].includes(searchTerm)
          )
          .map((fromParams) =>
          parameters.map((toParams) => {
            if (fromParams !== toParams) {
              const url = `/calculator/ar/unit_converter/area/${fromParams}/${toParams}/`;
              return (
                <tr key={`${fromParams}-${toParams}`}>
                  <td>{parameterNames[fromParams]}</td>
                  <td>{parameterNames[toParams]}</td>
                  <td>
                    <a href={url}>
                      تحويل من  {parameterNames[fromParams]} إلى{" "}
                      {parameterNames[toParams]}
                    </a>
                  </td>
                </tr>
              );
            }
            return null;
          })
        )}
      </tbody>
    </table>
  );
  return (
    <div>
      <div className="container rtl-container">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div>
          <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
          <hr />
          <div className="alert alert-secondary" role="alert">
            <p>{DESCRIPTION}</p>
          </div>
        </div>
        <hr />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "15px",
          }}
        >
          <h2 style={{ margin: 0 }}>المساحة</h2>
          <input
            type="text"
            placeholder="ابحث عن وحدة..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              width: "200px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
        {renderTable(areas, areaParameters)}
        <br />
      </div>
    </div>
  );
}
export default UnitsList;
